import styled from "styled-components";

export const Error = styled.div`
  max-width: 210px;
  margin-top: 10px;
  color: #f40012;
  font-size: 14px;
`;

export const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90vw",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  overflow: "scroll",
  height: "100%",
};
